<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-left">
          <BreadcrumbsHelper :breadcrumbs="this.Breadcrumbs" />
        </div>
        <!--end left col -->
        <div class="col-lg-12 text-right"></div>
        <!--end right col -->
      </div>
    </div>
    <div class="container text-left">
      <b-card class="mt-2">
        <div class="row">
          <div class="col-lg-6">
            <h1 class="title">Social Networks</h1>
          </div>
          <div class="col-lg-6 text-right">
            <router-link :to="{ name: 'social networks create' }" class="event-link-btn">
              <button class="btn btn-secondary"><font-awesome-icon class="icon" icon="plus" /> New Network</button>
            </router-link>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="table-responsive">
              <table class="table table-sm table-striped text-left">
                <thead>
                  <tr class="text-left">
                    <th>Title</th>
                    <th>Base URL</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="tr-sections" v-for="sn in $store.state.misc.social_networks" :key="sn._id">
                    <td>
                      <router-link :to="{ name: 'social networks detail', params: { netId: sn._id } }" class="link">{{ sn.name }}</router-link>
                    </td>
                    <td>
                      <a :href="sn.base_url" aria-label="opens in a new window" rel="noopener noreferrer" target="_blank" class="base-url link">{{ sn.base_url }}</a>
                    </td>
                    <td class="text-right">
                      <span class="ellipsis"
                        ><router-link :to="{ name: 'social networks detail', params: { netId: sn._id } }" class="btn btn-sm btn-secondary"
                          >View Details</router-link
                        ></span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import BreadcrumbsHelper from '../common/BreadcrumbsHelper.vue';

export default {
  components: {
    BreadcrumbsHelper,
  },
  data() {
    return {
      Breadcrumbs: [
        {
          text: 'Dashboard',
          href: '/admin',
          active: false,
        },
        {
          text: 'Settings',
          active: true,
        },
        {
          text: 'Social Networks',
          active: true,
        },
      ],
      networkOptions: [],
    };
  },
  props: ['value'],
  async mounted() {
    await this.$store.dispatch('misc/getSocialNetworks');
    this.networkOptions = this.$store.state.misc.social_networks.map(sn => ({ text: sn.name, value: sn.name, url: sn.base_url }));
  },
};
</script>

<style lang="scss" scoped>
.icon {
  font-size: 12px;
  line-height: 30px !important;
  padding-right: 2px;
  text-align: center;
}
.link {
  color: black;
  text-decoration: underline;
}
.card {
  border: none;
}
</style>
